// Global error handlers to catch and log any unhandled errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
  
  // Don't prevent default behavior, just log for debugging
  return false;
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
  
  // Don't prevent default - allow errors to be visible
  // event.preventDefault();
});

console.log('Global error handlers setup complete');

export {}; // Make this a module